/*
 * Module for the body of a sortable list
 */

define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListBody/sortableListBodyView",
], function (Marionette, Backbone, _, Messenger, SortableListBodyView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "sortableListBody";
      this.region = options.region;
      this.headers = options.headers;
      this.paginationFilter = options.paginationFilter;
      this.extendedEvents = options.extendedEvents;
      this.namespace = options.namespace;
      if (this.namespace) {
        this.namespacePrefix = this.namespace + ":";
      } else {
        this.namespacePrefix = "";
      }
      this._setUpVents();
      this._setUpReqres();
    },
    show: function (collection) {
      this.checkedModels = [];
      this.collection = collection;
      //handle updated checkboxes when a checked model is removed from the collection
      this.listenTo(
        collection,
        "remove",
        function (model) {
          if (model.checked) {
            model.checked = false;
            //remove model from the checked list
            this._handleCheckedList(model);
            //update that the checkboxes has changed
            Messenger.vent.trigger(this.namespacePrefix + "changed:checkboxes");
          }
        },
        this,
      );

      //handle updating checkboxes when multiple checked models are removed from the collection
      this.listenTo(
        collection,
        "removeMultiple",
        function (modelArray) {
          let checkboxesChanged = false;
          _.each(
            modelArray,
            function (model) {
              if (model.checked) {
                checkboxesChanged = true;
                model.checked = false;
                //remove model from the checked list
                this._handleCheckedList(model);
              }
            },
            this,
          );
          if (checkboxesChanged) {
            //update that the checkboxes has changed
            Messenger.vent.trigger(this.namespacePrefix + "changed:checkboxes");
          }
        },
        this,
      );
      this.view = new SortableListBodyView.sortableListBodyView({
        collection: collection,
        headers: this.headers,
        paginationFilter: this.paginationFilter,
        extendedEvents: this.extendedEvents,
      });
      this.view.on(
        "itemview:selected:row",
        function (view) {
          Messenger.vent.trigger(this.namespacePrefix + "selected:row", view.model);
        },
        this,
      );
      this.view.on(
        "itemview:toggle:checkbox",
        function (view) {
          //toggle checked attribute
          view.model.checked = !view.model.checked;
          //add or remove model from list
          this._handleCheckedList(view.model);
          //toggle icon to reflect change
          this._toggleCheckbox(view);
          //trigger changed event
          Messenger.vent.trigger(this.namespacePrefix + "changed:checkboxes");
        },
        this,
      );

      this.view.on(
        "itemview:dragged:item",
        function (view) {
          //set up a reqres for the dragged object when the drag begins (needs to be done here as
          //opposed to setUpReqres because it needs to override any existing reqres)
          Messenger.reqres.setHandler(
            "dragged:model",
            function () {
              return view.model;
            },
            this,
          );
        },
        this,
      );

      this.view.on(
        "itemview:model:dropped",
        function (view) {
          //get the dragged model
          const draggedModel = Messenger.reqres.request("dragged:model");
          //fire an event saying that the model was dropped onto this row, and pass the
          //dropped model and the row's model
          Messenger.vent.trigger(this.namespacePrefix + "dropped:on:row", draggedModel, view.model);
        },
        this,
      );
      this.showRegion(this.view);
    },
    update: function (collection) {
      this.view.collection = collection;
      this.view.render();
    },
    _getCheckedModels: function () {
      return this.checkedModels;
    },
    _handleCheckedList: function (model) {
      if (model.checked) {
        //add to map
        this.checkedModels.push(model);
      } else {
        this.checkedModels = _.reject(this.checkedModels, function (checkedModel) {
          return checkedModel.cid === model.cid;
        });
      }
    },
    _toggleCheckbox: function (view) {
      view.$el.find("#checkbox").toggleClass("icon-check-empty");
      view.$el.find("#checkbox").toggleClass("icon-check");
    },
    _toggleAllCheckboxes: function (checked) {
      //a little tricky here: we iterate through each model and see
      //whether the model is checked when we want everything to be unchecked (or vice versa)
      //and correct the value (and update the view)
      //We only want to deal with non-filtered out models
      this.collection.each(function (model) {
        if (!model.filteredOut && model.checked !== checked) {
          model.checked = checked;
          model.trigger("enter"); //update itemView, if it exists
          if (checked) {
            this._handleCheckedList(model);
          }
        }
      }, this);
      if (!checked) {
        //shortcut so we don't have to remove each model individually with a O(n) operation
        this.checkedModels = [];
      }
      //trigger change event (even if there really weren't any changed checkboxes...
      //at least for now)
      Messenger.vent.trigger(this.namespacePrefix + "changed:checkboxes");
    },
    _setUpVents: function () {
      Messenger.vent.on(
        this.namespacePrefix + "toggle:all:checkboxes",
        function (checked) {
          this._toggleAllCheckboxes(checked);
        },
        this,
      );
      //sort list
      Messenger.vent.on(
        this.namespacePrefix + "sort:list",
        function (sortObj) {
          const header = sortObj.header;
          console.log("sort:list");
          if (this.collection) {
            this.collection.comparator = function (a, b) {
              //we sort the collection directly (not view.collection)
              let result;
              if (header.get("textField") || header.get("longTextField")) {
                result = Backbone.textComparator(a, b, header.get("modelAttribute"));
              } else if (header.get("arrayField")) {
                result = Backbone.arrayComparator(a, b, header.get("modelAttribute"));
              } else if (header.get("dateField")) {
                result = Backbone.dateComparator(a, b, header.get("modelAttribute"));
              } else {
                result = Backbone.numericComparator(a, b, header.get("modelAttribute"));
              }
              if (sortObj.reverse) {
                return -result;
              } else {
                return result;
              }
            };
            this.collection.sort();
          }
        },
        this,
      );
      //filter list
      Messenger.vent.on(
        this.namespacePrefix + "filter:list",
        function (filterFunction) {
          if (this.collection) {
            //use filter function to filter collection
            this.collection.each(function (model) {
              model.filteredOut = !filterFunction(model);
            });
            //uncheck all the models (a little inefficient, but leaving this way for code clarity
            //at this time)
            this._toggleAllCheckboxes(false);
            //trigger filter event
            this.collection.trigger("filter");
          }
        },
        this,
      );
      Messenger.vent.on(this.namespacePrefix + "change:page", () => this.view.render(), this);
    },
    _setUpReqres: function () {
      Messenger.reqres.setHandler(
        this.namespacePrefix + "checked:models",
        function () {
          return this._getCheckedModels();
        },
        this,
      );
    },
  });
});
